import { C8NodeType } from "csi/typings";
import { ComponentItem } from "designSystem/types/component-item-types";
import { size } from "lodash";

export class CustomViewNodeContexts {
	/** the map between context id and name  */
	#mapIdToName: Record<string, string> = {};

	/** context type */
	readonly contextType?: C8NodeType;

	/** review type */
	readonly forState?: boolean;

	/** indicate if the context has multiple contexts  */
	get hasMultiple(): boolean {
		return size(this.#mapIdToName) > 1;
	}

	/** list of subtype item */
	get subTypeList(): ComponentItem[] {
		const result: ComponentItem[] = [];

		for (const [id, name] of Object.entries(this.#mapIdToName)) {
			result.push({ id, name });
		}

		return result;
	}

	/** add context */
	addContext = (id: string, name: string): void => {
		this.#mapIdToName[id] = name;
	};

	/** get the context name by the id */
	getNameByContextId = (idContext): string => {
		return this.#mapIdToName[idContext];
	};

	constructor(contextType: C8NodeType, forState: boolean) {
		this.contextType = contextType;
		this.forState = forState;
	}
}